import * as React from "react";
import ShiftCategory from "../../presentations/ShiftCategory";

const ShiftCategoryContainer = (props: any) => {
  const { data } = props;

  return (
    <div>
      <ShiftCategory data={data}></ShiftCategory>
    </div>
  );
};

export default ShiftCategoryContainer;
